import React, { useState, useEffect } from 'react';
import axios from 'axios';

// interface User {
//     id: string;
//     name: string;
//     productionItem: Record<string, string>; // Object with item IDs as keys and quantities as values
//     productionId: number; // Production ID for the assignment API
//     // Add other user properties as needed
// }


interface User {
    id: string;
    name: string;
    productionItem: Array<{ materialTypeId: string;[key: string]: any }>; // Array of objects
    productionId: number;
}


interface DdpTemplate {
    id: string;
    skuName: string;
    productName: string;
    categoryName: string;
    itemName: string;
    itemId: string;
    franchiseId: string;
    // Add other template properties as needed
}

interface AssignDdpProps {
    user: User;
    onClose?: () => void; // Add onClose prop to close the modal
}

const AssignDdp: React.FC<AssignDdpProps> = ({ user, onClose }) => {
    const [templates, setTemplates] = useState<DdpTemplate[]>([]);
    const [selectedTemplate, setSelectedTemplate] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const [isAssigning, setIsAssigning] = useState<boolean>(false);

    useEffect(() => {
        fetchTemplates();
    }, []);

    const fetchTemplates = async () => {
        setLoading(true);
        try {
            // Get the first key from user.productionItem
            const firstProductionItemKey = user.productionItem ? Object.keys(user.productionItem)[0] : null;

            if (!firstProductionItemKey) {
                console.error('No production item found in user data');
                setLoading(false);
                return;
            }

            // const response = await axios.get(`${process.env.REACT_APP_BASE_API_URL}dpp/item/${user.productioItem[0].materialTypeId}`);
            const response = await axios.get(`${process.env.REACT_APP_BASE_API_URL}dpp/item/${user.productionItem[0].materialTypeId}`);
            setTemplates(response.data.data || response.data || []);
        } catch (error) {
            console.error('Error fetching DDP templates:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleAssign = async () => {
        if (!selectedTemplate) {
            alert('Please select a DDP template');
            return;
        }

        if (!user.productionId) {
            alert('Production ID not found');
            return;
        }

        setIsAssigning(true);
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_BASE_API_URL}productions/${user.productionId}/assignDpp?dppId=${selectedTemplate}`,
                '',
                {
                    headers: {
                        'User-Agent': 'okhttp/4.9.2',
                        'Accept': 'application/json',
                        'Accept-Language': 'en-US,en;q=0.5',
                        'Accept-Encoding': 'gzip, deflate, br, zstd',
                        'Content-Type': 'application/json',
                        'app-id': '3',
                        'client-id': '101212',
                        'Origin': 'http://localhost:3065',
                        'Connection': 'keep-alive',
                        'Referer': 'http://localhost:3065/',
                        'Sec-Fetch-Dest': 'empty',
                        'Sec-Fetch-Mode': 'cors',
                        'Sec-Fetch-Site': 'cross-site',
                        'Priority': 'u=0'
                    }
                }
            );

            // Show toast message (you'll need to import this from your toast utility)
            // successToast('Assigned');

            // Close the modal
            if (onClose) {
                onClose();
            }

            // Reset form
            setSelectedTemplate('');
        } catch (error) {
            console.error('Error assigning DDP template:', error);
            alert('Error assigning DDP template');
        } finally {
            setIsAssigning(false);
        }
    };

    return (
        <div className="assign-ddp-container">
            <div className="mb-4">
                <h4 className="fw-bold fs-5 mb-3">Select DDP Template</h4>

                <div className="fv-row mb-4">
                    <select
                        className="form-control form-control-solid"
                        value={selectedTemplate}
                        onChange={(e) => setSelectedTemplate(e.target.value)}
                        disabled={loading || isAssigning}
                        style={{
                            backgroundColor: 'white',
                            border: '1px solid #cdcdcd',
                            color: 'black'
                        }}
                    >
                        <option value="">
                            {loading ? 'Loading templates...' : 'Select a DDP template...'}
                        </option>
                        {templates.map((template) => (
                            <option key={template.id} value={template.id}>
                                {template.categoryName} - {template.itemName} - {template.productName}
                            </option>
                        ))}
                    </select>
                </div>

                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleAssign}
                    disabled={!selectedTemplate || isAssigning || loading}
                    style={{
                        backgroundColor: '#333333',
                        border: 'none',
                        padding: '10px 24px',
                        borderRadius: '8px',
                        fontWeight: '500'
                    }}
                >
                    {isAssigning ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Assigning...
                        </>
                    ) : (
                        'Assign'
                    )}
                </button>
            </div>
        </div>
    );
};

export default AssignDdp;